import { createSlice }  from '@reduxjs/toolkit';
import { firebaseServices } from '../../Firebase/FirebaseServices';
import DBLastVisitFrameUpdate from '../../Functions/DBLastVisitFrameUpdate';
import DBScroeUpdate from '../../Functions/DMScoreUpdate';
export const generalSlice = createSlice({
    name:'generalSlice',
    initialState:{
        currentPage: 0, // starts from 0  CommponPages => 0..2,  Episode1 => 3--26, Episode2 => 27--54, Episode3 => 55-74
        score: Array(6).fill(false),
        EP2_score: Array(7).fill(false),
        EP3_score: Array(4).fill(false),
        name: '',
        dbSavedTimeStamp: 'dump',
        ep1_lastVisitFrame: 0,
        ep2_lastVisitFrame: 0,
        ep3_lastVisitFrame: 0,
    },
    reducers:{
        pageUp: (state) => {state.currentPage++},
        pageDown: (state) => {state.currentPage--},
        setPage: (state, num) => {state.currentPage = num.payload},
        scoreUp: (state, info) => {state.score[info.payload.index] = info.payload.answer; if(state.dbSavedTimeStamp !== 'dump'){DBScroeUpdate('episode1', state.score, state.dbSavedTimeStamp)};},
        scoreReset: (state) => {state.score = Array(6).fill(false)},
        EP2_scoreUp: (state, info) => {state.EP2_score[info.payload.index] = info.payload.answer; if(state.dbSavedTimeStamp !== 'dump'){DBScroeUpdate('episode2', state.EP2_score, state.dbSavedTimeStamp)};},
        EP2_scoreReset: (state) => {state.EP2_score = Array(7).fill(false)},
        EP3_scoreUp: (state, info) => {state.EP3_score[info.payload.index] = info.payload.answer; if(state.dbSavedTimeStamp !== 'dump'){DBScroeUpdate('episode3', state.EP3_score, state.dbSavedTimeStamp)};},
        EP3_scoreReset: (state) => {state.EP3_score = Array(4).fill(false)},
        playAgain: (state) => {state.currentPage=2},
        setPlayerName: (state, name) => {state.name = name.payload},
        set_dbSavedTimeStamp: (state, timeStamp) => {state.dbSavedTimeStamp = timeStamp.payload},

        set_ep1_lastVisitFrame: (state, cp) => {state.ep1_lastVisitFrame = (cp.payload > state.ep1_lastVisitFrame) ? `${state.ep1_lastVisitFrame = cp.payload}` : `${state.ep1_lastVisitFrame}`;DBLastVisitFrameUpdate('episode1', state.ep1_lastVisitFrame, state.dbSavedTimeStamp);},
        set_ep2_lastVisitFrame: (state, cp) => {state.ep2_lastVisitFrame = (cp.payload > state.ep2_lastVisitFrame) ? `${state.ep2_lastVisitFrame = cp.payload}` : `${state.ep2_lastVisitFrame}`;DBLastVisitFrameUpdate('episode2', state.ep2_lastVisitFrame, state.dbSavedTimeStamp);},
        set_ep3_lastVisitFrame: (state, cp) => {state.ep3_lastVisitFrame = (cp.payload > state.ep3_lastVisitFrame) ? `${state.ep3_lastVisitFrame = cp.payload}` : `${state.ep3_lastVisitFrame}`;DBLastVisitFrameUpdate('episode3', state.ep3_lastVisitFrame, state.dbSavedTimeStamp);}
    }
});

export const {pageUp, pageDown, setPage, scoreUp, scoreReset, EP2_scoreUp, EP2_scoreReset, EP3_scoreUp, EP3_scoreReset, playAgain, setPlayerName, set_dbSavedTimeStamp, set_ep1_lastVisitFrame, set_ep2_lastVisitFrame, set_ep3_lastVisitFrame} = generalSlice.actions;

export const currentPage = (state) => {return(state.generalSlice.currentPage)};
export const score = (state) => {return(state.generalSlice.score)};
export const EP2_score = (state) => {return(state.generalSlice.EP2_score)};
export const EP3_score = (state) => {return(state.generalSlice.EP3_score)};
export const getName = (state) => {return(state.generalSlice.name)};
export const dbSavedTimeStamp = (state) => {return(state.generalSlice.dbSavedTimeStamp)};

export const ep1_lastVisitFrame = (state) => {return(state.generalSlice.ep1_lastVisitFrame)};
export const ep2_lastVisitFrame = (state) => {return(state.generalSlice.ep2_lastVisitFrame)};
export const ep3_lastVisitFrame = (state) => {return(state.generalSlice.ep3_lastVisitFrame)};



export default generalSlice.reducer